import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from 'reactstrap';
import "./index.scss";
const Item = ({ item, __handleSelectedAction }) => {
	return (
		<>
			<Button
				color="link"
				className="text-start d-inline-flex align-items-center item"
				onClick={() => __handleSelectedAction(item?._source?.loan_number, { _id: item?._id })}
				data-toggle="tooltip" data-placement="top" title={item?._source?.taxpayer_name ? item?._source?.taxpayer_name : ''}
			>
				
				<label>
					
					{item?._source?.loan_number + (item?._source?.taxpayer_name ? ` (${item._source.taxpayer_name})` : '')}

				
				</label>
			</Button>
		</>
	);
}

export default Item;